import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { setAuthority, setToken, setUserId } from '@/features/Login/login'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { Header } from '@/components/Header'
import jiangshanqiusetu from '@/assets/images/jiangshanqiusetu.png'
import hanxizaiyeyantu from '@/assets/images/hanxizaiyeyantu.png'
import xieshengzhenqintu from '@/assets/images/xieshengzhenqintu.jpg'
import './index.less'
import { login, register as _register } from '@/server'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/pagination'
import { EffectFade, Pagination, Autoplay } from 'swiper'
import { message } from 'antd'
import { setNowComparePage } from '@/features/SetCompareTypeList/setCompareTypeList'
import { setNowPage, setSelectedType } from '@/features/SetOverviewTypeList/setOverviewTypeList'
import { setLikesNowPage } from '@/features/SetLikesPageList/setLikesPageList'
import { setShowWorkId } from '@/features/SetShowWorkId/setShowWorkId'
import {
  setCompareImageId,
  setCompareWorkId
} from '@/features/SetCompareImageInfo/setCompareImageInfo'
import {
  setAnalysisImageId,
  setAnalysisWorkId
} from '@/features/SetAnalysisImageInfo/setAnalysisImageInfo'
import { setShowType } from '@/features/SetCompareInfo/setCompareInfo'

export function LoginPage() {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const token = useAppSelector((state) => state.login.token)
  const [username, setUsername] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [_email, setEmail] = useState<string>('')
  const [selectedState, setSelectedState] = useState<string>('登录')

  useEffect(() => {
    if (token) navigate('/index', { replace: true })
  }, [token, navigate])

  function handleSubmit() {
    if (selectedState === '登录') {
      login({
        username,
        password
      }).then((res) => {
        if (res.data.code === '0') {
          dispatch(setUserId(username))
          dispatch(setToken(res.data.content.token))
          //切换用户时，初始化
          dispatch(setNowComparePage(1))
          dispatch(setNowPage(1))
          dispatch(setLikesNowPage(1))
          dispatch(setSelectedType(0))
          dispatch(setAnalysisWorkId(''))
          dispatch(setAnalysisImageId(''))
          dispatch(setShowType(0))
          dispatch(setShowWorkId(''))
          dispatch(setCompareWorkId(''))
          dispatch(setCompareImageId(''))
          dispatch(setAuthority(res.data.content.role))
          navigate('/index')
        } else {
          message.error('账号或密码错误！')
          navigate('/')
        }
      })
    } else {
      message.warning('注册功能尚未开放！')
      // register({
      //   username,
      //   password,
      //   email
      // }).then((res) => {
      //   console.log(res)
      // })
    }
  }
  function handleUsername(e) {
    setUsername(e.target.value)
  }
  function handlePwd(e) {
    setPassword(e.target.value)
  }
  function handleEmail(e) {
    setEmail(e.target.value)
  }
  function handleSwitch(e) {
    setSelectedState(e.target.innerText)
  }
  function handleEnter(e) {
    if (e.key !== 'Enter') return
    handleSubmit()
  }
  return (
    <>
      <div className='login-register-container'>
        <div className='login-register-header'>
          <Header hideHeaderBtn />
        </div>
        <div className='login-register-body'>
          <div className='login-register-switch'>
            <div
              className={
                selectedState === '注册'
                  ? 'switch-button switch-button-unselected'
                  : 'switch-button'
              }
              onClick={(e) => handleSwitch(e)}
            >
              登录
            </div>
            <div
              className={
                selectedState === '登录'
                  ? 'switch-button switch-button-unselected'
                  : 'switch-button'
              }
              onClick={(e) => handleSwitch(e)}
            >
              注册
            </div>
          </div>
          <div className='input-container' onKeyDown={(e) => handleEnter(e)}>
            <input
              type='text'
              placeholder='账号'
              onBlur={(e) => handleUsername(e)}
              onChange={(e) => handleUsername(e)}
            />
            <input
              type='password'
              placeholder='密码'
              onBlur={(e) => handlePwd(e)}
              onChange={(e) => handlePwd(e)}
            />
            <input
              className={selectedState === '注册' ? '' : 'email-input-hide'}
              type='email'
              placeholder='电子邮箱'
              onBlur={(e) => handleEmail(e)}
            />
            <div className='confirm-button' onClick={handleSubmit}>
              {selectedState}
            </div>
          </div>
        </div>
        <div className='swiper-container'>
          <Swiper
            loop={true}
            spaceBetween={30}
            effect={'fade'}
            pagination={{
              clickable: true,
              clickableClass: 'my-pagination-clickable'
            }}
            autoplay={{
              delay: 5000,
              pauseOnMouseEnter: false
            }}
            modules={[EffectFade, Pagination, Autoplay]}
            className='mySwiper'
          >
            <SwiperSlide>
              <img src={jiangshanqiusetu} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={hanxizaiyeyantu} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={xieshengzhenqintu} />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </>
  )
}
